import clsx from "clsx";
import { Page } from "../components/page";
import translate from "../locales";
import { SourceMaterialCard } from "../components/info-sources/source-material-card";
import { ContinueCard } from "../components/info-sources/source-continue-card";

export function InfoSourcesPage({ onNext }) {
  const onClickContinue = () => {
    onNext?.();
  };

  return (
    <Page className="info-sources">
      <title>{translate("info-sources.page-title")}</title>
      <div className={clsx("info-sources-container page__content--padded")}>
        <h1 className={clsx("title")}>
          {translate("info-sources.page.title")}
        </h1>
        <SourceMaterialCard />
        <ContinueCard
          img={
            <svg
              width="72"
              height="71"
              viewBox="0 0 72 71"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.9852 42.5148C28.5858 42.1161 28.0443 41.892 27.4799 41.892C26.9156 41.892 26.3741 42.1162 25.9747 42.5148L21.0047 47.4848C20.606 47.8842 20.3818 48.4257 20.3818 48.9901C20.3818 49.5545 20.606 50.096 21.0047 50.4953C21.4103 50.8825 21.9493 51.0983 22.5099 51.0983C23.0706 51.0983 23.6096 50.8824 24.0152 50.4953L28.9852 45.5253C29.3839 45.126 29.608 44.5845 29.608 44.0201C29.608 43.4557 29.3839 42.9142 28.9852 42.5148Z"
                fill="#002B6C"
              />
              <path
                d="M45.2302 28.4C45.2302 29.5764 44.2766 30.53 43.1002 30.53C41.9238 30.53 40.9702 29.5764 40.9702 28.4C40.9702 27.2236 41.9238 26.27 43.1002 26.27C44.2766 26.27 45.2302 27.2236 45.2302 28.4Z"
                fill="#002B6C"
              />
              <path
                d="M50.9099 37.8004L53.7499 34.9604C55.1036 33.6159 56.1771 32.0161 56.9084 30.2538C57.6397 28.4916 58.0141 26.6017 58.0099 24.6938V19.17C58.0099 17.6636 57.4116 16.2189 56.3463 15.1536C55.2811 14.0884 53.8364 13.49 52.3299 13.49H46.8133C44.9052 13.4859 43.0156 13.8603 41.2533 14.5915C39.491 15.3228 37.8912 16.3964 36.5465 17.75L33.7065 20.59H23.2198C20.7718 20.59 18.4241 21.5626 16.6931 23.2934C14.9622 25.0242 13.9897 27.372 13.9897 29.8201C13.9902 30.3847 14.2151 30.9262 14.6145 31.3253L17.8733 34.5841H17.8735C18.9158 35.626 20.3294 36.2112 21.8032 36.2112C23.2771 36.2112 24.6906 35.626 25.7332 34.5841L39.5498 20.7533C40.5016 19.797 41.6336 19.0391 42.8805 18.5235C44.1271 18.0081 45.4639 17.7451 46.8132 17.7499H52.3298C52.7063 17.7499 53.0676 17.8994 53.3338 18.1659C53.6003 18.4322 53.7498 18.7934 53.7498 19.1699V24.6865C53.7547 26.0358 53.4917 27.3725 52.9763 28.6192C52.4606 29.8661 51.7028 30.9982 50.7464 31.9499L36.9156 45.7665C35.8737 46.8091 35.2885 48.2226 35.2885 49.6965C35.2885 51.1703 35.8737 52.5839 36.9156 53.6262L40.1744 56.885V56.8852C40.5735 57.2846 41.115 57.5095 41.6796 57.51C44.1277 57.51 46.4754 56.5374 48.2063 54.8066C49.9372 53.0758 50.9097 50.728 50.9097 48.2799L50.9099 37.8004ZM22.7158 31.5666C22.4704 31.8072 22.1401 31.9421 21.7964 31.9421C21.4525 31.9421 21.1225 31.8072 20.8768 31.5666L18.2996 28.9893L18.3989 28.5987C18.6707 27.5266 19.2925 26.5755 20.1656 25.8965C21.039 25.2174 22.1137 24.8493 23.2198 24.8499H29.4394L22.7158 31.5666ZM46.6499 48.28C46.6506 49.3861 46.2824 50.4608 45.6034 51.3342C44.9243 52.2074 43.9733 52.8291 42.9011 53.1009L42.5105 53.2003L39.9333 50.623C39.6892 50.3792 39.5519 50.0484 39.5519 49.7034C39.5519 49.3586 39.6892 49.0278 39.9333 48.784L46.6499 42.0603L46.6499 48.28Z"
                fill="#002B6C"
              />
            </svg>
          }
          title="info-sources.continue.subtitle"
          description="info-sources.continue.description"
          labelNext="info-sources.continue.button"
          onClick={onClickContinue}
        />
      </div>
    </Page>
  );
}
